
import { getAuthHookFactory } from "../../../../global/paywall/useAuth";
import { AuthStepsEnum, SignInType } from "../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallMobileSigninEmail } from "./signin/premiumPaywallMobileSigninEmail"
import { PremiumPaywallState } from "../desktop/premiumPaywallDesktop";
import PremiumPaywallCheckoutPlans from "../desktop/premiumPaywallPlans";
import { PremiumPaywallMobileSigninPassword } from "./signin/premiumPaywallMobileSigninPassword";
import { PremiumPaywallMobileSigninFinish } from "./signin/premiumPaywallMobileSigninFinish";



interface PremiumPaywallMobileLoginProps {
  emailOrPhone: string
  password: string
  agreesTerms: boolean
  setEmailOrPhone: (emailOrPhone: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  setIsRedirecting: (isRedirect: boolean) => void
  isNewspaper?: boolean;

}

export const PremiumPaywallMobileSignin = (props: PremiumPaywallMobileLoginProps) => {
  const { emailOrPhone, setEmailOrPhone, password, setPassword, setMode, agreesTerms, setIsRedirecting, isNewspaper } = props
  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailOrPhoneForLogin,
    submitPassword,
    proceedToEmailStep,
    user,
    setAuthError,
    signInType,
    setSignInType
  } = getAuthHookFactory("login")();


  const sendMail = () => {
    sendEmailOrPhoneForLogin(emailOrPhone, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }


  switch (step) {
    case AuthStepsEnum.PLANS:
      return (
        <PremiumPaywallCheckoutPlans
          proceedToEmailStep={proceedToEmailStep}
          setMode={setMode}
        />)
    case AuthStepsEnum.EMAIL:
      return (
        <PremiumPaywallMobileSigninEmail
          emailOrPhone={emailOrPhone}
          setEmailOrPhone={setEmailOrPhone}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
          isNewspaper={isNewspaper}
          setAuthError={setAuthError}
          setSignInType={setSignInType}
          signInType={signInType}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumPaywallMobileSigninPassword
          emailOrPhone={emailOrPhone}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          sendMail={sendMail}
          authError={authError}
          setEmailOrPhone={setEmailOrPhone}
          signInType={signInType}
        />
      )

    case AuthStepsEnum.CONFIRM_TERMS:
      // if its sign in, we dont need to confirm terms
      onThirdPartyLogin(false)
      return null

    case AuthStepsEnum.FINISH:
      return <PremiumPaywallMobileSigninFinish user={user} setIsRedirecting={setIsRedirecting} />
    default:
      return null
  }
};
